export default "__VITE_ASSET__BMVGY1f___"